import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { fontStyles } from 'theme';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NavLink = styled(Link)`
  background-image: ${({ $url }) => `url(${$url})`};
  background-size: cover;
  background-position: center;
  background-color: var(--color-white);
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 5px;
  color: var(--color-white);
  cursor: pointer;
  transition: transform 0.3s;
  text-decoration: none;
  position: relative;
  @media (hover) {
    &:hover {
      transform: scale(1.02);
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;
  padding: 4px 8px;
`;

export const Title = styled.p`
  ${fontStyles.regularSmall}
  @media (max-width: 1023px) {
    ${fontStyles.small}
  }
`;

export const Text = styled.p`
  ${fontStyles.regularSmall}
  @media (max-width: 1023px) {
    ${fontStyles.small}
    & > span {
      ${fontStyles.small}
    }
  }
`;

export const Mark = styled.p`
  position: absolute;
  top: 0;
  right: 15px;
  border: 1px solid var(--color-primary);
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  background-color: var(--color-white);
  ${fontStyles.regularLargeBold}
  color: var(--color-primary);
  padding: 3px 10px;
`;
